import React, { useEffect, useState } from 'react';
import { Api } from '../../api/Api';
import './Faq.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { ServerUrl } from '../../api/ServerUrl';

const Faq = () => {
    const { http } = Api();
    const [faq, setFaq] = useState([]);
    const [backImage, setBackImage] = useState([]);
    const [activeIndex, setActiveIndex] = useState(null);

    useEffect(() => {
        http.get('/get-front-faq')
            .then(res => {
                setFaq(res.data.data);
                setBackImage(res.data.backImage);
                setActiveIndex(0);
            })
            .catch(error => {
                console.error('Error fetching FAQ:', error);
            });
    }, []);


    const toggleFaq = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    return (
        <div>
            <Helmet>
                <title>Frequently Asked Questions</title>
                <meta name="description" content={backImage.meta_description} />
                <meta property="og:title" content={backImage.og_title || backImage.meta_title} />
                <meta property="og:description" content={backImage.og_description || backImage.meta_description} />
                {backImage.og_image && (
                    <meta property="og:image" content={`${ServerUrl}/backend/img/back_image/${backImage.og_image}`} />
                )}
            </Helmet>

            <section className="faq-section mt-5">
                <div className="container mt-3">
                    <h2 className="faq-heading color-primary mb-4 pb-4">Frequently Asked Questions </h2>
                    <div className="faq-list">
                        {faq.map((item, index) => (
                            <div
                                className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                                key={index}
                            >
                                <div className="faq-question" onClick={() => toggleFaq(index)}>
                                    {item.question}
                                    <span className="faq-icon">{activeIndex === index ? '▲' : '▼'}</span>
                                </div>
                                <div
                                    className="faq-answer"
                                    style={{
                                        maxHeight: activeIndex === index ? '200px' : '0px',
                                        padding: activeIndex === index ? '15px 20px' : '0 20px',
                                    }}
                                >
                                    <p className='mb-0'>{item.answar}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Faq;
